import dynamic from 'next/dynamic';

import { CancellationProps } from './HotelCancellationPolicy.types';

export const HotelCancellationPolicyMGP = dynamic<CancellationProps>(() => import('./HotelCancellationPolicy'));
